<template>
  <div :class="[`nav-theme-${navTheme}`]">
    <a-layout id="components-layout-demo-side" style="min-height:100vh">
      <a-layout-sider
        class="no-print"
        :theme="navTheme"
        :trigger="null"
        collapsible
        v-model="collapsed"
      >
        <div class="logo">
          <img @click="goHome" :src="collapsed ? logoClose : logoOpen" />
        </div>
        <SiderMenu :theme="navTheme" />
      </a-layout-sider>
      <a-layout>
        <a-layout-header class="headerStyle do-not-print-me-header">
          <a-icon
            class="trigger "
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="collapsed = !collapsed"
          ></a-icon>
          <Header />
        </a-layout-header>
        <a-layout-content>
          <div>
            <router-view></router-view>
          </div>
        </a-layout-content>

        <a-layout-footer class="no-print" style="text-align:center">
          <Footer />
        </a-layout-footer>
      </a-layout>
    </a-layout>
    <Authorized :authority="['user']">
      <SettingDrawer />
    </Authorized>
  </div>
</template>
<script>
import Header from "./Header";
import SiderMenu from "./SiderMenu";
import Footer from "./Footer";
import SettingDrawer from "@/components/SettingDrawer/index";
// import logo from "@/assets/logo.png";
// console.log(lang);
export default {
  data() {
    return {
      collapsed: false,
      logoOpen: require("../assets/logo.png"),
      logoClose: require("../assets/bird.png")
    };
  },
  components: {
    Header,
    Footer,
    SiderMenu,
    SettingDrawer
  },
  computed: {
    navTheme() {
      return this.$route.query.navTheme || "dark";
    }
  },
  methods: {
    goHome() {
      this.$router.push({ name: "home" });
    }
  }
};
</script>
<style lang="less">
.trigger {
  padding: 0 28px;
  line-height: 36px;
  font-size: 20px;
}
.trigger:hover {
  background: #eee;
}
.ant-layout-header {
  height: 36px;
  line-height: 36px;
}
#components-layout-demo-side .logo {
  height: 40px;
  // background: #ffffff33;
  margin: 10px;
  img {
    height: 40px;
    margin-left: 10%;
  }
}
.ant-layout-header {
  display: flex;
  background: #fff;
  flex-direction: row;
  justify-content: space-between;
  padding: 0;
  padding-right: 3%;
}
.logo img {
  cursor: pointer;
}
</style>
